<template>
  <transition name="retail-notes">
    <div
      v-if="visible"
      class="order-notes-modal"
      role="dialog"
      aria-modal="true"
      @click.self="cancel"
    >
      <section class="order-notes-dialog">
        <header class="order-notes-header">
          <div>
            <span class="order-notes-eyebrow">
              <i class="fas fa-clipboard"></i>
              {{ $t('retailSale.notesModal.eyebrow') }}
            </span>
            <h2>{{ $t('retailSale.notesModal.title') }}</h2>
            <p>{{ $t('retailSale.notesModal.subtitle') }}</p>
          </div>
          <button
            type="button"
            class="order-notes-close"
            :aria-label="$t('retailSale.notesModal.close')"
            @click="cancel"
          >
            <i class="fas fa-times"></i>
          </button>
        </header>

        <div class="order-notes-body">
          <textarea
            ref="notesInput"
            v-model="draft"
            rows="5"
            :placeholder="$t('retailSale.notesModal.placeholder')"
          ></textarea>
        </div>

        <footer class="order-notes-footer">
          <button type="button" class="order-notes-cancel" @click="cancel">
            {{ $t('retailSale.notesModal.cancel') }}
          </button>
          <button type="button" class="order-notes-save" @click="save">
            <i class="fas fa-check"></i>
            {{ $t('retailSale.notesModal.save') }}
          </button>
        </footer>
      </section>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'OrderNotesModal',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    notes: {
      type: String,
      default: ''
    }
  },
  data() {
    return { draft: '' }
  },
  watch: {
    visible(value) {
      if (!value) return

      this.draft = this.notes || ''
      this.$nextTick(() => this.$refs.notesInput.focus())
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    save() {
      this.$emit('save', this.draft.trim())
    }
  }
}
</script>

<style scoped src="../../styles/order-notes-modal.css"></style>
